import { createContext } from 'react';
import { AdvertContactsLoadContextType } from '#advertContacts/contexts';

const AdvertContactsLoadContext = createContext<AdvertContactsLoadContextType>(null);

export { AdvertContactsLoadContext };
